import { Button } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'
import { RoleCode } from '@eastcoal/shared/enums/RoleCode'

import { AbortiveExplainStatus } from '../../../enums/AbortiveExplainStatus'
import { AuctionOperationPageStatus } from '../../../enums/AuctionOperationPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { AbortiveExplainAuditButtonProps } from './interface'

export const AbortiveExplainAuditButton = ({
  record
}: AbortiveExplainAuditButtonProps) => {
  const roles = useAuthStore(state => state.roles)
  const hasPermission = roles.some(role => role.code === RoleCode.DEPTMANAGER)

  const {
    setCurrentAuction,
    setAbortiveExplainFormMode,
    toggleAbortiveExplainVisible
  } = useAuctionListStore(state =>
    pick(state, [
      'setCurrentAuction',
      'setAbortiveExplainFormMode',
      'toggleAbortiveExplainVisible'
    ])
  )

  const handleClick = () => {
    setCurrentAuction(record)
    setAbortiveExplainFormMode(FormMode.UPDATE)
    toggleAbortiveExplainVisible(true)
  }

  return hasPermission &&
    record.explainStatus === AbortiveExplainStatus.WAIT_AUDIT &&
    record.status === AuctionOperationPageStatus.DEAL_FAIL ? (
    <Button type='link' onClick={handleClick}>
      审核说明
    </Button>
  ) : null
}
